import AuthComponent from 'components/auth';
import React from 'react';
import Layout from '../Layout';
import {
  FormContainer,
  Image,
  LeftSection,
  RightSection,
} from '../styles';

interface ISigninViewProps {
  lang: string;
}

const SigninView: React.FC<ISigninViewProps> = () => (
  <Layout>
    <LeftSection>
      <Image />
    </LeftSection>
    <RightSection>
      <FormContainer>
        <AuthComponent />
      </FormContainer>
    </RightSection>
  </Layout>
);

export default SigninView;
